// Small SWR-lite hooks so components can subscribe to backend data cleanly.
import { useCallback, useEffect, useRef, useState } from "react";

export function useFetch(fn, deps = [], { enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const cancelledRef = useRef(false);

  const reload = useCallback(async () => {
    if (!enabled) return;
    setLoading(true); setError(null);
    try {
      const res = await fn();
      if (!cancelledRef.current) setData(res);
    } catch (e) {
      if (!cancelledRef.current) setError(e);
    } finally {
      if (!cancelledRef.current) setLoading(false);
    }
    // `deps` is a user-provided array; `fn` intentionally isn't included
    // because callers usually inline it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps]);

  useEffect(() => {
    cancelledRef.current = false;
    reload();
    return () => { cancelledRef.current = true; };
  }, [reload]);

  return { data, error, loading, reload, setData };
}
